import { createTheme } from '@mui/material/styles';
import palette from './palette';
import typography from './typography';
import {
  buttonOverrides,
  chipOverrides,
  fabOverrides,
  muiFilledInputOverrides,
  muiFormControlLabelOverrides,
  muiIconButtonOverrides,
  muiInputBaseOverrides,
  muiLinearProgressOverrides,
  muiListItemIconOverrides,
  muiOutlinedInputOverrides,
  muiPaperOverrides,
  muiSvgIconOverrides,
  muiTableCellOverrides,
  muiTableOverrides,
  muiTableRowOverrides,
  muiTabOverrides,
  muiTabsOverrides,
} from './overrides';
import transitions from './transitions';
import shadows from './shadows';

const theme = createTheme({
  palette,
  typography,
  components: {
    MuiButton: buttonOverrides,
    MuiChip: chipOverrides,
    MuiFab: fabOverrides,
    MuiFilledInput: muiFilledInputOverrides,
    MuiFormControlLabel: muiFormControlLabelOverrides,
    MuiIconButton: muiIconButtonOverrides,
    MuiInputBase: muiInputBaseOverrides,
    MuiLinearProgress: muiLinearProgressOverrides,
    MuiListItemIcon: muiListItemIconOverrides,
    MuiOutlinedInput: muiOutlinedInputOverrides,
    MuiPaper: muiPaperOverrides,
    MuiSvgIcon: muiSvgIconOverrides,
    MuiTab: muiTabOverrides,
    MuiTable: muiTableOverrides,
    MuiTableCell: muiTableCellOverrides,
    MuiTableRow: muiTableRowOverrides,
    MuiTabs: muiTabsOverrides,
  },
  transitions,
  custom: {
    shadows,
  },
  zIndex: {
    appBar: 1200,
    drawer: 1100,
  },
});
export default theme;
